const koMessages = {
  /* 01.General */
  "chat.end": "채팅 대화 다시 시작",
  "chat.endall": "채팅 종료",
  "chat.cancel": "취소",
  "chat.cookie": "이 디지털 비서는 쿠키를 사용하여 최고의 경험을 보장합니다.",
  "chat.learn": "더 알아보기",
  "chat.minimize": "최소화",
  "chat.hide": "닫다",
  "chat.hidebot.text": "닫기를 누르면 아바타가 15분 동안 사라집니다.",
  "chat.hidebot": "봇 닫기",
  "chat.restart": "재시작",
  "switch.language": "언어 전환",
  "switch.property": "속성 전환",
  "restart.converstation": "대화 다시 시작",
  "chat.endtext": "현재 채팅을 종료하시겠습니까?",
  "check.availabity": "가용성 확인",
  "check.availabity.submit": "제출하다",
  "check.availabity.cancel": "취소",
  "check.availabity.adults": "성인 ",
  "check.availabity.children": "어린이들",
  "check.availabity.child.age": "나이 - 아이",
  "feedback.leave": "피드백 남기기",
  "feedback.leave.message": "메시지 남기기",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "사례 제출",
  "caseform.system": "시스템",
  "caseform.loading.systems": "시스템을 로딩 중...",
  "caseform.select.system": "시스템 선택",
  "caseform.error.systems": "시스템 로딩 오류",
  "caseform.scenario": "시나리오",
  "caseform.loading.scenarios": "시나리오를 로딩 중...",
  "caseform.select.scenario": "시나리오 선택",
  "caseform.error.scenarios": "시나리오 로딩 오류",
  "caseform.topic": "주제",
  "caseform.loading.topics": "주제를 로딩 중...",
  "caseform.select.topic": "주제 선택",
  "caseform.error.topics": "주제 로딩 오류",
  "caseform.subject": "제목",
  "caseform.description": "설명",
  "caseform.submit": "제출",
  "caseform.cancel": "취소",
  "caseform.success.title": "사례 생성됨",
  "caseform.success.message": "사례가 성공적으로 생성되었습니다.",
  "caseform.success.caseNumber": "사례 번호:",
  "caseform.success.ok": "OK",
  "simpleaction.title": "작업 선택",
  "simpleaction.body":
    "다음 옵션 중 하나를 선택하세요:{br}{b}사례 만들기{/b} 지원 요청을 제출하거나 {b}채팅 시작{/b} 지금 에이전트와 연결하려면.",
  "simpleaction.startchat": "채팅 시작",
  "simpleaction.createcase": "사례 만들기",
  "caseform.error.generic": "사례 생성 중 오류가 발생했습니다.",
  "caseform.error.generic.message":
    "사례를 만드는 동안 오류가 발생했습니다. 나중에 다시 시도하십시오.",
};
export default koMessages;
